import { Component, Host, h, JSX, Prop } from '@stencil/core'
import { toDecimal } from '@rdss/core'

@Component({
    tag: 'zr-rating-badge',
    styleUrl: 'zr-rating-badge.scss',
    shadow: true,
})

/**
 * ZooRoyal ratings component.
 */
export class ZrRatingBadge {
    /**
     * Rating Value.
     */
    @Prop() value: number

    /**
     * Rating count.
     */
    @Prop() count: number

    /**
     * Hide rating count.
     */
    @Prop() hideCount = false

    /**
     * Current App Language for displaying numbers.
     */
    @Prop() locale = 'de-DE'

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                {this.count > 0
                    ? <div class='zr-rating-badge__wrapper' title={toDecimal(this.value / 2, this.locale) + ' Sterne'}>
                        <div class="zr-rating-badge__icon zr-rating-badge__active-star"></div>
                        <span>{toDecimal(this.value / 2, this.locale)} {!this.hideCount && `(${this.count})`}</span>
                    </div>
                    : <div class='zr-rating-badge--spacer'></div>
                }
            </Host>
        )
    }
}
